const template = document.createElement('template');
template.innerHTML = `
<style>
  .personalisation-image-selector {
    display: flex;
    gap: 0.625rem;
    margin-bottom: 1.25rem;
    position: relative;
  }

  .personalisation-image-selector.is-hidden {
    display: none;
  }

  .image-option {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.0625rem solid var(--transparent-navy-navy-12);
    border-radius: 0.5rem;
    min-height: 1.375rem;
    min-width: 3.5rem;
    cursor: pointer;
    background-color: transparent;
    padding: 0.5rem 1.25rem;
    font-size: 1.25rem;
    font-weight: 485;
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    text-transform: uppercase;
    color: var(--button-text);
  }

  .image-option.is-active {
    border-color: var(--button-text);
  }

  .image-option-label {
    display: none;
  }

  @media screen and (max-width: 1100px) {
    .image-option {
      font-size: 0.9375rem;
    }
  }
</style>

<div class="personalisation-image-selector" style="display: none;">
  <label class="image-option is-active" for="bottle">BOTTLE</label>
  <input class="image-option-label" type="radio" id="bottle" name="image-type" value="Bottle" checked>
  <label class="image-option" for="box">BOX</label>
  <input class="image-option-label" type="radio" id="box" name="image-type" value="Box">
</div>
`;

export class PersonalisationImageSelector extends HTMLElement {
  private readonly root:HTMLDivElement|null;
  private readonly isHidden = this.hasAttribute('is-hidden');

  constructor() {
    super();

    // Attach shadow root
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    this.root = shadowRoot.querySelector('.personalisation-image-selector');

    if (this.isHidden) {
      this.root?.classList.add('is-hidden');
    }
  }

  connectedCallback() {
    this.root?.addEventListener('change', (e) => {
      if (e.target instanceof HTMLInputElement && e.target.name === 'image-type') {
        const imageType = e.target.value;
        this.dispatchEvent(new CustomEvent('image_selected', {
          bubbles: true,
          composed: true,
          detail: {
            imageType
          }
        }));

        this.updateActiveLabel(e.target.id);
      }
    });

    this.dispatchEvent(new CustomEvent('image_selected', {
      bubbles: true,
      composed: true,
      detail: {
        imageType: 'Bottle'
      }
    }));
  }

  updateActiveLabel(labelName: string) {
    const labels = this.root?.querySelectorAll('.image-option');
    labels?.forEach(label => {
      if (label.htmlFor === labelName.toLowerCase()) {
        label.classList.add('is-active');
      } else {
        label.classList.remove('is-active');
      }
    });
  }

  setDefaultImageType() {
    this.updateActiveLabel('Bottle');

    const defaultImageInput = this.root.querySelector('input#bottle');
    if (defaultImageInput) {
        defaultImageInput.checked = true;
    }
  }
}


if(!customElements.get('personalisation-image-selector')) {
  customElements.define('personalisation-image-selector', PersonalisationImageSelector);
}